import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { WithdrawForm } from '@/features/consumer/withdraw-form';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/withdraw/'
)({
  component: WithdrawPage,
});

function WithdrawPage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/my-wallet' })}
        />
        <HeaderDashboard.Title>Withdraw</HeaderDashboard.Title>
      </HeaderDashboard>
      <WithdrawForm />
    </div>
  );
}
